import { useEffect } from 'react';

export function useOnClickOutside(ref, handler, condition = true) {
    useEffect(() => {
        if (condition) {
            const listener = (event) => {
                if (
                    ref?.length &&
                    ref?.find((r) => r?.current?.contains(event?.target)) !==
                        undefined
                )
                    return;

                if (
                    !ref?.length &&
                    (!ref.current || ref.current.contains(event.target))
                ) {
                    return;
                }

                handler(event);
            };

            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        }
    }, [ref, handler, condition]);
}
